<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ params.value }}</span>
    </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'Company') return 'danger'
        else if (value === 'Person') return 'warning'
        else if (value === true) return 'success'
        else if (value === false) return 'danger'
        else if (value === '5/5') return 'success'
        else if (value === '4/5') return 'success'
        else if (value === '3/5') return 'warning'
        else if (value === '2/5') return 'warning'
        else if (value === '1/5') return 'danger'
        else if (value === '0/5') return 'danger'
        else return ''
      }
    }
  }
}
</script>
